import React from 'react';
import { MdList, MdDashboard, MdAdd, MdRefresh, MdNoteAdd } from 'react-icons/md';

type ActiveTab = 'dashboard' | 'coupon-input' | 'coupon-list';

interface MenuProps {
  activeTab: ActiveTab;
  setActiveTab: (tab: ActiveTab) => void;
  isOpen: boolean;
  onToggle: () => void;
  onNewProject: () => void;
  onResetToTemplate: () => void;
}

export default function Menu({ activeTab, setActiveTab, isOpen, onToggle, onNewProject, onResetToTemplate }: MenuProps) {
  const menuItems = [
    { id: 'dashboard', icon: MdDashboard, label: 'ダッシュボード' },
    { id: 'coupon-input', icon: MdNoteAdd, label: 'クーポン発行入力' },
    { id: 'coupon-list', icon: MdList, label: 'クーポン一覧' }
  ];

  return (
    <aside className={`sidebar-menu ${isOpen ? 'open' : 'closed'}`}>
      <div className="menu-header">
        <div className="menu-logo">
          <button 
            className="menu-logo-icon" 
            onClick={onToggle}
            title={isOpen ? 'メニューを閉じる' : 'メニューを開く'}
          >
            {isOpen ? '◀' : '▶'}
          </button>
          {isOpen && (
            <div className="menu-logo-text" onClick={() => setActiveTab('dashboard')}>
              <h3>メニュー</h3>
            </div>
          )}
        </div>
      </div>
      
      <nav className="menu-nav">
        <ul className="menu-list">
          {menuItems.map((item) => {
            const IconComponent = item.icon as any;
            return (
              <li key={item.id} className="menu-item">
                <button
                  className={`menu-button ${activeTab === item.id ? 'active' : ''}`}
                  onClick={() => setActiveTab(item.id as ActiveTab)}
                  title={!isOpen ? item.label : undefined}
                >
                  <span className="menu-icon"><IconComponent /></span>
                  {isOpen && (
                    <div className="menu-content">
                      <span className="menu-label">{item.label}</span>
                    </div>
                  )}
                </button>
              </li>
            );
          })}
        </ul>
      </nav>

      <div className="menu-actions">
        <button 
          className="menu-action-button menu-reset" 
          onClick={onResetToTemplate}
          title={!isOpen ? 'テンプレートに戻す' : undefined}
        >
          <span className="menu-icon">{React.createElement(MdRefresh as any)}</span>
          {isOpen && (
            <div className="menu-content">
              <span className="menu-label">リセット</span>
            </div>
          )}
        </button>
      </div>
    </aside>
  );
}